module.exports = __webpack_public_path__ + "img/imghuanxhy-xz.a56e42cc.png";